/**
 * Currency display helper.
 *
 * Reglas de visualización (Iter 62d · Feb 2026):
 *   - **CEO y Proveedor CU** ven el código técnico literal (`USDT`).
 *   - **Gestor y Cliente** ven `USDT` → "USD" (es el saldo interno; mismo activo,
 *     etiqueta amigable).
 *   - **`USD` siempre se muestra como "USD Clásica"** porque cuando aparece el
 *     código `USD` en la app, es destino de remesa (corredor tarjeta USD).
 *     ADR-010: BANDEC también se mapea a "USD Clásica".
 *
 * Mantén este mapping en UN solo lugar.
 */

// Etiqueta que SOLO ve gestor/cliente cuando el código es USDT (su saldo).
const GESTOR_CLIENT_ALIASES = {
  USDT: 'USD',
};

// Alias universal (todos los roles): el código `USD` SIEMPRE se renderiza como
// "USD Clásica" en la UI — porque el motor solo usa USD como destino de remesa.
// Idem BANDEC (legacy → unificado en USD por ADR-010).
const UNIVERSAL_ALIASES = {
  USD:    'USD Clásica',
  BANDEC: 'USD Clásica',
};

/**
 * @param {string} code  - currency code (UYU, USDT, CUP, MLC, BANDEC, USD)
 * @param {object} opts  - { isAdmin: bool, withCode: bool }
 * @returns {string}     - role-aware display label
 */
export const displayCurrency = (code, { isAdmin = false, withCode = false } = {}) => {
  if (!code) return '';
  const c = String(code).toUpperCase();
  if (UNIVERSAL_ALIASES[c]) {
    return withCode ? `${UNIVERSAL_ALIASES[c]} (${c})` : UNIVERSAL_ALIASES[c];
  }
  if (isAdmin) return c;
  const alias = GESTOR_CLIENT_ALIASES[c];
  if (!alias) return c;
  return withCode ? `${alias} (${c})` : alias;
};

/** Returns true if a given role should see the technical code. */
export const isAdminRole = (role) => role === 'admin' || role === 'payment_agent';
